import { css } from "@emotion/react";

import { titleToID } from ".";

type Props = {
  titles: string[];
};

const Header: React.FC<Props> = ({ titles }) => {
  /**
   * クリック時対象のセクションにスクロールする
   */
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <div css={mainStyle}>
      <div css={contentsWrapperstyle}>
        {titles.map((title) => (
          <div
            key={title}
            onClick={() => scrollToSection(titleToID(title))}
            css={itemStyle}
          >
            {title}
          </div>
        ))}
      </div>
    </div>
  );
};

const primaryColor = "#D90012";
const spSize = 768;

const mainStyle = css`
  width: 100%;
  height: 108px;
  display: flex;
  justify-content: center;
  background-color: white;

  @media (max-width: ${spSize}px) {
    height: 40px;
  }
`;

const contentsWrapperstyle = css`
  max-width: 1062px;
  width: 85%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  @media (max-width: ${spSize}px) {
    width: 95%;
  }
`;

const itemStyle = css`
  padding: 0 13px;
  min-width: 130px;
  height: 48px;
  font-family: MyFont;
  font-size: 14px;
  background-color: ${primaryColor};
  color: white;
  line-height: 48px;

  @media (max-width: ${spSize}px) {
    padding: 0 5px;
    min-width: 40px;
    height: 20px;
    font-size: 6px;
    line-height: 20px;
  }

  &:hover {
    cursor: pointer;
  }
`;

export default Header;
